export const findDuplicates = (list) => {
  let sorted_arr = list.slice().sort();
  let results = [];

  for (let i = 0; i < sorted_arr.length - 1; i++) {
    if (sorted_arr[i + 1].email === sorted_arr[i].email) {
      results.push(sorted_arr[i].email);
    }
  }
  return results;
}